import Vue from "vue"
import Vuei18n from "vue-i18n"

// NOTE: Vuei18n exposes its own `vue/types/vue` module
Vue.use(Vuei18n)
